import { Component, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { delay } from 'rxjs';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'risk-total-loss',
    templateUrl: './risk-total-loss.component.html',
    styleUrls: ['./risk-total-loss.component.scss'],
    standalone: false
})
export class RiskTotalLossComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  error: ValidationErrors = null;
  options: FormControlOption[] = [
    {
      value: true,
      label: 'Oui',
      suffix: { title: 'A' },
    },
    {
      value: false,
      label: 'Non',
      suffix: { title: 'B' },
    },
  ];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    this.form
      .get('riskTotalLoss')
      .valueChanges.pipe(
        delay(0),

        untilDestroyed(this),
      )
      .subscribe(data => {
        if (data == false) {
          this.form.get('riskTotalLoss').setErrors({
            incorrect: true,

            message:
              'Afin de pouvoir finaliser votre souscription, merci de confirmer la perte intégrale de votre investissement.',
          });
        } else {
          this.form.get('riskTotalLoss').setErrors(null);
        }
        this.error = this.form.get('riskTotalLoss').errors;
      });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
